export const applePayAvailable = () => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isAppleDevice = /iPhone|iPad|Macintosh/.test(navigator.userAgent);

  if (!isSafari || !isAppleDevice) return false;

  if (typeof window.ApplePaySession === 'undefined') return false;
  // eslint-disable-next-line no-undef
  if (!ApplePaySession.canMakePayments()) return false;

  return true;
};
